"use client";

import TopFrame from "./Frame";

export default function HomeScreen() {
    return <TopFrame />
}